export default "__VITE_ASSET__CeCcwFhU__"